import { createContext, useState, useContext, useEffect, useCallback } from "react";
import PropTypes from "prop-types";

const KeikkaBetoniContext = createContext();

export const KeikkaBetoniProvider = ({ children, keikkaId }) => {
  const [keikkaBetoniId, setKeikkaBetoniId] = useState();

  useEffect(() => {
    if (!keikkaId) return;
    const _asynk = async () => {
      //do something here
    };
    _asynk();
  }, [keikkaId]);

  const doSetKeikkaBetoniId = useCallback(
    (keikkaBetoniId) => {
      setKeikkaBetoniId(keikkaBetoniId);
    },
    [keikkaBetoniId]
  );

  return (
    <KeikkaBetoniContext.Provider value={{ keikkaBetoniId, doSetKeikkaBetoniId }}>
      {children}
    </KeikkaBetoniContext.Provider>
  );
};

export const useKeikkaBetoniData = () => useContext(KeikkaBetoniContext);

KeikkaBetoniProvider.propTypes = {
  children: PropTypes.node.isRequired,
  keikkaId: PropTypes.number,
};
